import type { MailboxInfo } from 'owa-client-types';
import { getAccountKeyForMailboxInfo } from 'owa-client-types';
import { getGroupsStore } from '../GroupsStore';
import type { GroupsState } from '../schema/GroupsState';
import type GroupInformation from '../schema/GroupInformation';

export function getGroupsState(mailboxInfo: MailboxInfo): GroupsState {
    const accountKey = getAccountKeyForMailboxInfo(mailboxInfo);
    const groupsState = getGroupsStore().groupsStateByMailboxInfo.get(accountKey);

    if (!groupsState) {
        const defaultGroupsState: GroupsState = {
            groups: new Map<string, GroupInformation>(),
        };

        getGroupsStore().groupsStateByMailboxInfo.set(accountKey, defaultGroupsState);
        return defaultGroupsState;
    }

    return groupsState;
}
